<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.iowText" style="width: 140px;" size="small " placeholder="请输入文字内容"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.iopId" clearable @change="partserch" placeholder="请选择岗位"
                        style="width: 130px">
                        <el-option v-for="(item, index) in getIvOnlinePostList_data || []" :label="item.iopName"
                            :value="item.iopId" :key="index"></el-option>
                    </el-select>

                    <el-select size="small" v-model="formDatas.iowType" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="问题" :value="1" key="2"></el-option>
                        <el-option label="旁白" :value="2" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建视频库</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="iowId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑视频库' : '新增视频库'" :visible.sync="dialog" width="70%" top="8vh"
                :before-close="handleClose">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="类型" prop="iowType">
                            <el-select size="small" v-model="form.iowType" clearable placeholder="请选择类型"
                                style="width: 130px">
                                <el-option label="问题" :value="1" key="2"></el-option>
                                <el-option label="旁白" :value="2" key="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="岗位" prop="iopId">
                            <el-select size="small" v-model="form.iopId" clearable 
                                placeholder="请选择岗位" style="width: 130px">
                                <el-option v-for="(item, index) in getIvOnlinePostList_data || []" :label="item.iopName"
                                    :value="item.iopId" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文字内容" prop="iowText">
                            <el-input v-model="form.iowText" style="width: 100%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="提示" prop="iowTip">
                            <el-input v-model="form.iowTip" style="width: 100%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="视频" prop="iowVideoPath">
                            <my-uploadVideo ref="iowVideoPathupload" @fileChange="iowVideoPathChange"
                                :filearr="iowVideoPathfileList" :limit="1" style="margin: 10px 5px 5px" type="video"
                                @removeAfter="form.iowVideoPath = '',iowVideoPathfileList = []">
                            </my-uploadVideo>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 详情 -->
            <el-dialog title="统计" :visible.sync="isDetail" width="70%" top="8vh" :before-close="detailClose">
                <div style="margin: 15px;display: flex;">
                    <el-date-picker v-model="dateStart" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                        size="small" @change="getAnLiList">
                    </el-date-picker>
                    <span style="margin: 0 10px">-</span>
                    <el-date-picker v-model="dateEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                        size="small" @change="getAnLiList">
                    </el-date-picker>
                    <el-button type="primary" size="small" style="margin-left: 10px" @click="Out()">导出</el-button>
                </div>
                <ve-table ref="vetable" v-if="detailTable" :columns="columnDetail" :table-data="detailTable"
                    :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="qprId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                <div v-show="detailTable.length == 0" class="empty-data">暂无数据</div>
            </el-dialog>
        </div>
        <div style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;z-index: 999;background-color: black;"
            v-if="isVideo">
            <div style="width: 100%;height:100%;overflow: hidden;position: relative;">
                <video controls :src="videofile" style="width: 100%;height: 100%;"></video>
                <div style="width: 50px;height: 50px;background-color:rgba(255, 5, 5,0.5);line-height: 50px;text-align: center;
              border-radius: 100%;font-size: 23px;color: white;position:absolute;top: -15px;right: -15px;"
                    @click.capture.stop="videoPreViewClose()" v-if="videofile != ''">
                    ✖
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import config from "../../api/env.js";
import {
    addIvOnlineWare, deleteIvOnlineWare, getIvOnlineWareList, updateIvOnlineWare,
    getNcUserList, getPkqPaperRecordList, getIvOnlinePostList,
    getIvOnlineWareDetails

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getIvOnlinePostList_data: [],
            dateStart: '',
            dateEnd: '',
            iowId: '',
            videofile: '',
            isVideo: false,
            iowVideoPathfileList: [],
            isDetail: false,
            detailTable: [],
            columnDetail: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "网格",
                    width: 180,
                    align: "center",
                    edit: false,
                    fixed: 'left',
                },
                {
                    field: "crlLength",
                    key: "crlLength",
                    title: "学习时长(s)",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "crlProgress",
                    key: "crlProgress",
                    title: "学习进度(s)",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "crlProgressPer",
                    key: "crlProgressPer",
                    title: "学习进度(%)",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "createdate",
                    key: "createdate",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                },

            ],
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'iowId',
            dialog: false,
            edit: false,
            form: {

            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "iowType",
                    key: "iowType",
                    title: "类型",
                    width: 150,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.iowType == 1 ? <el-tag type="danger">问题</el-tag> : <el-tag type="success">旁白</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "iopName",
                    key: "iopName",
                    title: "岗位",
                    width: 180,
                    align: "center",
                    edit: false,
                },
                {
                    field: "iowText",
                    key: "iowText",
                    title: "文字内容",
                    width: 180,
                    align: "center",
                    edit: false,
                },
                {
                    field: "iowTip",
                    key: "iowTip",
                    title: "提示",
                    width: 180,
                    align: "center",
                    edit: false,
                },
                {
                    field: "iowVideoPath",
                    key: "iowVideoPath",
                    title: "视频",
                    width: 150,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <div style="color:red;" on-click={() => this.videoPreView(row.iowVideoPath)}> 预览</div>
                                }
                            </span>
                        );
                    },
                },

                // {
                //     field: "crStatus",
                //     key: "crStatus",
                //     title: "状态",
                //     width: 150,
                //     align: "center",
                //     fixed: 'left',
                //     edit: false,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 {
                //                     row.crStatus == 3 ? <el-tag type="danger">下架</el-tag> : row.crStatus == 1 ? <el-tag type="danger">待发布</el-tag> : <el-tag type="success">上架</el-tag>
                //                 }
                //             </span>
                //         );
                //     },
                // },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {/*                                 
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: blue"
                                        on-click={() => this.gotoStatistics(row)}
                                    >
                                        统计
                                    </el-button>
                                } */}
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                iowText: '',
                crStatus: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getIvOnlinePostList({ pageSize: 0 }).then(res => {
            this.getIvOnlinePostList_data = res.data
        })
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            const bulkdata = {
                iowId: this.iowId, dateStart: this.dateStart, dateEnd: this.dateEnd
            };
            var s = qs.stringify(bulkdata);
            this.openLoading();
            var that = this;
            axios({
                method: "post",
                url: config.baseURL + "/pkq-case-video-look/exportPkqCaseVideoLook",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    userid: window.localStorage.getItem("paId"),
                },
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel",
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "统计.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success",
                    });
                }
            });

        },
        detailClose() {
            this.isDetail = false;
            this.dateEnd = '';
            this.dateStart = '';
        },
        getAnLiList() {
            getIvOnlineWareDetails({ iowId: this.iowId, dateStart: this.dateStart, dateEnd: this.dateEnd }).then(res => {
                this.detailTable = res.data;
            })
        },
        gotoStatistics(row) {
            this.iowId = row.iowId
            getIvOnlineWareDetails({ iowId: row.iowId }).then(res => {
                this.detailTable = res.data;
                this.isDetail = true;
            })
        },
        gotoUp(row) {
            this.$confirm("是否确定要上架吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvOnlineWareUp({ iowId: row.iowId }).then(res => {
                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        gotoDown(row) {
            this.$confirm("是否确定要下架吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvOnlineWareDown({ iowId: row.iowId }).then(res => {
                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        videoPreView(file) {
            this.videofile = file;
            this.isVideo = true;
        },
        videoPreViewClose() {
            this.isVideo = false;
        },
        crCoverChange(file) {
            console.log(file);
            this.$set(this.form, "crCover", file[0]);
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        iowVideoPathChange(file) {
            console.log(file);
            this.$set(this.form, "iowVideoPath", file[0]);
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        handleDetail(row) {
            getPkqPaperRecordList({ iowId: row.iowId }).then(res => {
                this.detailTable = res.data;
                this.isDetail = true;
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvOnlineWare({ iowId: row.iowId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                if(data.iowVideoPath){
                    const video = {
                    name: data.iowVideoPath,
                    url: data.iowVideoPath,
                }
                this.$set(this.iowVideoPathfileList, 0, video)
                }
               
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvOnlineWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvOnlineWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.iowVideoPathfileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.iowId = row.iowId
                    //console.log(jsonObj);
                    updateIvOnlineWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvOnlineWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvOnlineWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvOnlineWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>